import React from 'react';
import { Link as RouterLink } from 'react-router-dom';


import { Stack } from 'ui/stack';

import TruncatedCell from 'components/partials/table-component/truncated-cell/truncated-cell';

import type { AidModelDto } from 'api/generated/schemas/aidModelDto';

const ModelNameCell = ({
  model,
  detailsPath,
}: {
  model: AidModelDto;
  detailsPath: string;
}) => (
  <Stack sx={{ minWidth: 0, py: 0.5 }}>
    <RouterLink
      to={detailsPath}
      className="min-w-0 hover:underline"
      data-testid="aid-model-name-link"
    >
      <TruncatedCell value={model.name ?? ''} />
    </RouterLink>
    {model.isOriginal && (
      <span
        className="text-sm font-normal text-gray-500"
        data-testid="original-model-flag"
      >
        Original
      </span>
    )}
  </Stack>
);

export default ModelNameCell;
